import { DefaultService } from '@api-client/webapi-v2';
import { createQuery } from '@luna/api';

export const [
    useExternalIdentifiers,
    {
        queryApi: queryExternalIdentifiers,
        queryApiIfNeeded: queryExternalIdentifiersIfNeeded,
        selectData: selectExternalIdentifiersData,
    },
] = createQuery({
    name: 'statistics/webapi/v2/events/externalIdentifiers',
    payloadCreator: () => {
        return DefaultService.postEventsExternalIdentifiers({
            requestBody: {
                identifier: null,
            },
        });
    },
});
